module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "notifications-list"
  }, _vm._l((_vm.notifications), function(notif, index) {
    return _c('list-item', {
      attrs: {
        "notification": notif
      },
      on: {
        "navigate": _vm.bubbleUp
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6784c81a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/notifications/list.vue
// module id = 1156
// module chunks = 1